function useSignUpAndLogin(){

    
    
    function doLogin({userEmail, userPassword, isLogin}){
        if(isInputValid({userEmail, userPassword})){
            if(isLogin === true){
                return callServerToVerifyLogin({userEmail, userPassword, 
                    serverAccessAPI:"https://hotstar-api.herokuapp.com/login"});
            }
            else{
                return callServerToVerifyLogin({userEmail, userPassword, 
                    serverAccessAPI:"https://hotstar-api.herokuapp.com/signup"});
            }
        }
    }

    function isInputValid({userEmail,userPassword}){
        if(!userEmail || !userPassword){
            return false
        }
        return true;
    }

    function callServerToVerifyLogin({userEmail, userPassword, serverAccessAPI}){
        return verifyInfoWithServer({userEmail, userPassword, serverAccessAPI})
    }

    async function verifyInfoWithServer({userEmail, userPassword, serverAccessAPI}){
        const loginData = {name:userEmail.split("@")[0], emailaddress:userEmail, password:userPassword};
        const callServer = await fetch(serverAccessAPI, {
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify(loginData),
            redirect:"follow"
        });
        if(callServer.status === 200){
            const fetchResponseFromServer = await callServer.json();
            return await fetchResponseFromServer;
        }
        else{
            throw new Error("Login Failed")
        }
        
    }


    return {doLogin};

}

export default useSignUpAndLogin;